import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {CmsBannerComponent, CmsBannerComponentProps} from "../cms-banner/cms-banner.component";
import {AdminBannerComponent, AdminBannerComponentProps} from "../admin-banner/admin-banner.component";
import * as React from "react";

export interface BannerComponentProps extends CmsBannerComponentProps, AdminBannerComponentProps {
}

export class BannerComponent extends OrbitComponent<BannerComponentProps> {

    _shouldUseAdminBanner(): boolean {
        return this.services.adminBanner.adminBannerEnabled;
    }

    render() {
        return this._shouldUseAdminBanner() ? <AdminBannerComponent {...(this.props as AdminBannerComponentProps)}/> : <CmsBannerComponent {...(this.props) as CmsBannerComponentProps}/>;
    }
}